import supabase from "../../../shared/database/supabase";
import { ServiceOrderRepository } from "../../../models/service-order/service-order.repository";

export interface updateServiceOrderParams {
    serviceOrderId: string;
    costumerId: string;
}

export const updateServiceOrder = async (params: updateServiceOrderParams) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderRepository>("update-service-order", {
            body: JSON.stringify({
                service_order_id: params.serviceOrderId,
                costumer_id: params.costumerId,
            }),
        });

        if (error) {
            console.error("Error calling update-service-order:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in updateServiceOrder:", err);
        throw err;
    }
};